if (!customElements.get('pdp-size-guide-trigger')) {
  class PdpSizeGuideTrigger extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.button.addEventListener('click', () => {
        const modal = document.getElementById('pdp-size-guide');
        if (modal) modal.open(this.button);
      });
    }
  }

  customElements.define('pdp-size-guide-trigger', PdpSizeGuideTrigger);
}

if (!window.PdpSizeModal) {
  window.PdpSizeModal = class PdpSizeModal {
    constructor(el) {
      this.el = el;
      this.closeBtn = el.querySelector('[data-pdp-size-guide-close]');
      this.lastOpener = null;

      this.closeBtn?.addEventListener('click', () => this.close());
      this.el.addEventListener('click', (evt) => {
        if (evt.target === this.el) this.close();
      });
      this.keyupHandler = (evt) => {
        if (evt.key === 'Escape') this.close();
      };
    }

    open(opener) {
      this.lastOpener = opener || null;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.addEventListener('keyup', this.keyupHandler);
      document.documentElement.classList.add('overflow-hidden');
      this.closeBtn?.focus();
    }

    close() {
      if (!this.el.classList.contains('is-open')) return;

      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keyup', this.keyupHandler);
      document.documentElement.classList.remove('overflow-hidden');
      this.lastOpener?.focus();
    }
  };

  const initPdpSizeModal = () => {
    const el = document.getElementById('pdp-size-guide');
    if (!el || el.pdpSizeModal) return;

    const instance = new window.PdpSizeModal(el);
    el.pdpSizeModal = instance;
    el.open = (opener) => instance.open(opener);
    el.close = () => instance.close();
  };

  if (document.readyState !== 'loading') {
    initPdpSizeModal();
  } else {
    document.addEventListener('DOMContentLoaded', initPdpSizeModal);
  }

  document.addEventListener('shopify:section:load', initPdpSizeModal);
}
